<style type="text/css">
    .file::-webkit-file-upload-button {
        visibility: hidden;

    }

    .imageClass img {
        max-width: 190px;
        margin-right: 10px;
        margin-top: 10px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
    }

    .attClass {
/*
        min-width: 350px;
*/
        position: relative;
        padding: 5px;
        margin: 5px;
        text-align: left;
/*
        border: 1px solid #d0cccc7d;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
*/
        overflow: hidden;
    }

    .attClass:hover .delItem {
        display: block;
        top: 5px;
    }

    .soundClass {
        width: 350px;
        position: relative;
    }

    .soundClass audio {
        height: 45px;
    }


    .soundClass:hover .delItem {
        display: block;
        top: 15px;
    }

    .videoClass {
        width: 350px;
        position: relative;
        float: left;
        margin: 5px;
    }

    .videoClass video {
        background-color: #00005d;
        margin-right: 10px;
        margin-top: 10px;
        width: 340px;
        max-height: 300px;
    }

    .videoClass:hover .delItem {
        display: block;
    }

    .imageClass:hover .delItem {
        display: block;
    }

    .imageClass {
        float: left;
        margin: 5px;
        width: 200px;
        position: relative;
    }

    .delItem {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 0;
        right: 0;
        padding-left: 4px;
        font-weight: bold;
        border: 1px solid;
        border-radius: 10px;
        background-color: white;
        display: none;
    }

    .avatar {
        width: 80px;
        height: 80px;
        border-radius: 80px;
        padding: 5px;
        border: 1px solid gray;
        cursor: pointer;
    }

    .sampleTrademark {
        width: 250px;
        height: 250px;
        border-radius: 0px;
        padding: 5px;
        border: 1px solid gray;
        cursor: pointer;
    }

</style>
<template>
    <div @drop="dropFileHandle" style="clear: both">
        <img :src="avatarURL" v-if="fileType=='avatar'" class="avatar"
             @click="openFileDialog"
        />
        <img :src="avatarURL" v-else-if="fileType=='sampleTrademark'" class="sampleTrademark"
             @click="openFileDialog"
        />
        <v-text-field :label="label" v-model='fileName' v-else-if="inputType=='input'"
                      @click.native="openFileDialog"
                      append-icon='attach_file' :error="error" ref="text"
                      :error-messages="errorMessages"
        ></v-text-field>
        <div v-else-if="inputType=='nobutton'"></div>
        <v-btn :color="color" dark v-else @click="openFileDialog">
            <v-icon>attach_file</v-icon>
            {{label}}
        </v-btn>
        <div class="error--text" v-if="errorMessages != undefined && errorMessages != null && errorMessages != ''">
            {{errorMessages}}
        </div>
        <input type="file" :id="name" style="display: none" class="file" @change="onFilePicked" :accept="accept"/>
        <div v-if="fileType!='avatar' && fileType!='sampleTrademark' && items.length >0 && displayResult == true" v-for="item in items">
            <div v-if="fileType=='sound'" class="soundClass">
                <div v-if="readonly==false" class="delItem" @click="deleteAttach(item)">X</div>
                <audio controls>
                    <source :src="item.fileURL" type="audio/ogg">
                    Your browser does not support the audio element.
                </audio>
            </div>
            <div v-else-if="fileType=='video'" class="videoClass">
                <div v-if="readonly==false" class="delItem" @click="deleteAttach(item)">X</div>
                <video controls>
                    <source :src="item.fileURL" type="video/mp4">
                    Your browser does not support the video tag.
                </video>
            </div>
            <div v-else-if="fileType=='image'" class="imageClass">
                <div v-if="readonly==false" class="delItem" @click="deleteAttach(item)">X</div>
                <img :src="item.fileURL"/>
            </div>
            <div v-else-if="fileType=='normal'">
                <div v-if="readonly==false" class="delItem" @click="deleteAttach(item)">X</div>
                <a :href="item.fileURL">{{item.fileName}}</a>
            </div>
            <div v-else class="attClass">
                <div v-if="readonly==false" class="delItem" @click="deleteAttach(item)">X</div>
                <a :href="item.fileURL">{{item.fileName}}</a>
            </div>
        </div>
        <div style="clear: both"></div>
    </div>
</template>

<script>
    import {message} from "@/shared/message";
    import FormJS from "../../../public/plugin/form/form"
    import axios from "axios"

    export default {
        name: 'i-upload',
        components: {},
        inheritAttrs: false,
        props: {
            inputType: {
                type: String,
                default: "input"
            },
            displayResult: {
                type: Boolean,
                default: () => {
                    return true;
                }
            },
            accept: {
                type: String,
                default: '*'
            },
            type: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: ''
            },
            label: {
                type: String,
                default: ''
            },
            validate: {
                type: String,
                default: ''
            },
            maxLength: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String
            },
            readonly: {
                type: Boolean,
                default: false
            },
            value: {
                type: String | Number,
                default: ''
            },
            sourceId: {
                type: String,
                default: ''
            },
            sourceType: {
                type: String,
                default: ''
            },
            variable: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            multifile: {
                type: Boolean,
                default: () => {
                    return false;
                }
            },
            color:{
                type: String,
                default: () => {
                    return "primary";
                }
            },
            fileType: {
                type: String,
                default: 'attach'
            },
            eMessages: {
                type: String,
                default: () => {
                    return "";
                }
            },
            errorMessages: {
                type: String,
                default: ""
            }

        },
        watch: {
            value: function (data) {
                console.log(data);
                this.error = false;
                this.errorMessage = [];
                this.attachId = data;
                this.getAttach();
            },

            errorMessages:function(data){
                console.log("chan error messsage");
                console.log(data);
            },

            eMessages: function (data) {
                this.errorMessage = [data];
            },
            variable: function (data) {
                console.log(data);
                this.srcId = FormJS.normalizeSQL(this.sourceId, data);
                this.srcType = FormJS.normalizeSQL(this.sourceType, data);
            },
            error: function (data) {
                this.error = data;
            }
        },

        mounted(){
          //console.log(this.errorMessages);
        },

        created(){
            console.log("upload id:"+this.name);
            if(this.value != null && this.value != ""){
                this.attachId =this.value;
                this.getAttach();
            }
        },

        computed: {
            avatarURL: function () {
                if (this.items == null || this.items.length == 0) {
                    return "/img/icons/camera.png";
                } else {
                    return process.env.VUE_APP_API_URL + "/download/attach/" + this.items[0].attachId;
                }
            }
        },

        data: () => {
            return {
                show: false,
                values: {},
                items: [],
                pagination: {},
                pageSize: 10,
                currentPage: 1,
                totalRows: 0,
                fileContent: null,
                fileURL: null,
                fileName: null,
                uploadType:null,
                attachId: null,
                error: false,
                errorMessage: [],
                srcId: "",
                srcType: ""
            }
        },
        methods: {
            focus: function () {
                this.$refs.text.focus();
            },

            onInput: function (target) {
                this.$emit('input', target);
            },

            openFileDialog() {
                if (!this.readonly)
                    document.getElementById(this.name).click();
            },

            getAttach: function () {
                if (this.attachId == undefined || this.attachId == null || this.attachId == "") {
                    this.fileName = "";
                    this.fileURL = "";
                    this.items = [];
                    return;
                }
                axios.post(process.env.VUE_APP_API_URL + "/upload/list?ids=" + this.attachId).then(
                    data => {
                        for (let i = 0; i < data.length; i++) {
                            data[i].fileURL = process.env.VUE_APP_API_URL + "/download/attach/" + data[i].attachId;
                        }
                        this.items = data;
                        //this.attachId = data[0].attachId;
                        //this.fileName = data[0].fileName;
                        //this.fileURL = process.env.VUE_APP_API_URL+"/download/attach/"+data[0].attachId;
                    },
                    error => {
                        message.error("get attach failed");
                    }
                );

            },

            deleteAttach: function (item) {
                let attItems = this.items;
                for (let i = 0; i < attItems.length; i++) {
                    if (attItems[i].attachId == item.attachId) {
                        attItems.splice(i, 1);
                        break;
                    }
                }
                this.items = attItems;
                if (attItems.length == 0) {
                    this.attachId = ""
                } else {
                    this.attachId = attItems[0].attachId;
                    for (let i = 1; i < attItems.length; i++) {
                        this.attachId = this.attachId + "," + attItems[i].attachId;
                    }
                }
                this.$emit("input", this.attachId);
            },

            uploadFile: function (e) {
                let formData = new FormData();
                this.srcId = FormJS.normalizeSQL(this.sourceId, this.variable);
                this.srcType = FormJS.normalizeSQL(this.sourceType, this.variable);
                formData.append("uploadfile", this.fileContent);
                formData.append("sourceId", this.srcId);
                formData.append("sourceType", this.srcType);
                formData.append("attachTitle", this.label);
                axios.post(process.env.VUE_APP_API_URL + "/upload/save", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                }).then(
                    data => {
                        //console.log(this.multifile);
                        if (this.multifile) {
                            if (this.attachId == null || this.attachId == "") {
                                this.attachId = data.id;
                            } else {
                                this.attachId += "," + data.id;
                            }
                        } else {
                            this.attachId = data.id;
                        }
                        this.getAttach();
                        this.$emit("input", this.attachId);
                        data.type = this.uploadType;
                        this.$emit("change", data);
                    },
                    error => {
                        message.error("upload không thành công");
                        this.fileName = "";
                        e.target.value = "";
                    }
                );
            },

            onFilePicked: function (e) {
                const files = e.target.files
                if (files[0] !== undefined) {
                    this.fileName = files[0].name;
                    this.uploadType = files[0].type;
                    /*if (this.fileName.lastIndexOf('.') <= 0) {
                        return
                    }*/
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])
                    fr.addEventListener('load', () => {
                        this.fileURL = fr.result
                        this.fileContent = files[0] // this is an file that can be sent to server...
                        this.uploadFile(e);
                    })
                }
            },

            dropFileHandle: function (ev) {
                ev.preventDefault();

                if (ev.dataTransfer.items) {
                    // Use DataTransferItemList interface to access the file(s)
                    for (let i = 0; i < ev.dataTransfer.items.length; i++) {
                        // If dropped items aren't files, reject them
                        if (ev.dataTransfer.items[i].kind === 'file') {
                            var file = ev.dataTransfer.items[i].getAsFile();
                            console.log('havm... file[' + i + '].name = ' + file.name);
                            this.fileContent = file;
                            this.fileName = file.name;
                        }
                    }
                } else {
                    // Use DataTransfer interface to access the file(s)
                    for (let i = 0; i < ev.dataTransfer.files.length; i++) {
                        console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
                        this.fileName = ev.dataTransfer.files[i].name;
                        this.fileContent = ev.dataTransfer.files[i];
                        this.uploadFile(ev);
                    }
                }

            }
        }

    }
</script>
